import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React from 'react'
import JobSupportForm from './enquiryForms/job-support-form'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function JobSupport({SectionRef,title,location1,jobSupport}) {
  const jobSupportData =[
    {
     work:'Support Work for over 70+ Technologies',
     cnt:`Our plans of work-support are created as per your individual work or project needs. We have simple plans for beginners and advanced professionals alike who are looking for support in their roles and are willing to excel.`,
     expert:[
         {
         title:'Community of Expert Professionals',
         para:`With our online support for jobs comes a wealth of experience from approved mentors with real project handling experience and guidance for everyday job work. After support, you will be equipped with the knowledge and confidence to tackle any tasks given to you.`
         },
         {
         title:'Support Offerings',
         para:`Whatever the requirement is, you can always expect specialized help from us for your project. Our guided assistance guarantees that you acquire skills and knowledge that will enable you to accomplish the tasks without any worry`
         },],
     pay:['Pay Per Hour','Pay Per Week','Pay Per Monthly']  
 }
 ]
  return (
    <>
    <section className={`container`} ref={SectionRef}>
    <div className={`df fjsb gap20 projectdf whole-pdtb`}>
        <div className={`w55p mw100p`}>
           
        <h3 className={`fs-30 tfs-28 mfs-21 fwb600  ${popins.className}`}> {title && <span className={`ylw-clr ${popins.className}`}>  {title} Training with   </span> } Job Support Program </h3> 
        {jobSupportData.map((items,index)=>{
            return(
        <div className={``}key={index}>
       <h4 className={`fs-18 tfs-16 mfs-14 fwb600 mt20 tmt18 mmt16 ${popins.className}`}>{items.work}</h4>
       <p className={`fs-16 mfs-15 fwb400 mt18 mmt16 ${quickSand.className}`}>{items.cnt}</p>
       {items.expert.map((items,index)=>
        (
        <div className={``} key={index}>
        <h4 className={`fs-16 mfs-15 fwb500 mt20 tmt18 mmt16  ${popins.className}`}>{items.title}</h4>
        <p className={`fs-16 mfs-15 fwb400 mt18 mmt16  ${quickSand.className}`}>{items.para}</p>
        </div>
        ))}
                
        <div className={`df gap16 mgap5 mt24`}>
            {items.pay.map((items,index)=>(
           <div className={`df gap11 mgap5 fac`}key={index}>
            <Image src={"/new-course-details/project-arrow.png"} width={24} height={31} alt='Job support for career growth and success' loading='lazy' quality={100}/>
            <p className={`fs-16 mfs-12 fwb500  ${popins.className}`}>{items}</p>
            </div>
            ))}
        </div>
        </div>

        )})}
        </div>
        <JobSupportForm  title={"Post your  work support requirements"} {...(title ? { job: `${title} ` } : {})} />
    </div>
    </section>
    </>
  )
}
